import React from "react";
import { Box, FormControlLabel, Typography } from "@mui/material";
import MzCheckbox from "@markaaz/ui/MzCheckbox";

const sx = {
  checkboxField: {
    display: "flex",
    padding: "5px 20px",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: "20px",
    alignSelf: "stretch",
    marginRight: "0px",
    backgroundColor: "common.white",
    width: "480px",
    "&:first-child": {
      borderTopLeftRadius: "8px",
      borderTopRightRadius: "8px"
    },
    "&:last-child": {
      borderBottomLeftRadius: "8px",
      borderBottomRightRadius: "8px"
    }
  },
  checkbox: {
    "& .MuiCheckbox-root": {
      color: (theme) => theme.palette.darkBlue.c50
    },
    "& .Mui-checked": {
      color: (theme) => theme.palette.blue.c100
    }
  },
  formControl: { marginLeft: "0px", color: "darkBlue.c70" }
};

const checkboxField = ({ items, onCheckboxChange, rowData, values }) => {
  const isChecked = values[rowData.checkboxKey];

  return (
    <Box sx={sx.checkboxField}>
      <FormControlLabel
        sx={sx.formControl}
        control={<MzCheckbox sx={sx.checkbox} checked={isChecked} onChange={onCheckboxChange(rowData)} />}
        label={<Typography variant="body1">{items.label}</Typography>}
      />
    </Box>
  );
};

export default checkboxField;
